import { IncomeModel, IncomeType, OwnerOptionsDTO } from './api/useIncomeQuery';
import { IncomeData } from './useIncome';
import { WorkflowComponentProps } from '../../Workflow/Workflow.meta';

export type IncomeToUpsert = IncomeModel | { Id?: string; IncomeType?: IncomeType; Name?: string };

export interface IncomeToDelete {
  id: string;
  name: string;
}

export interface IncomeTableProps {
  incomeType: IncomeType;
  clientId: string;
  data: IncomeData;
  setIncomeToUpsert: (incomeToUpsert: IncomeToUpsert | null) => void;
  setIncomeToDelete: (incomeToDelete: IncomeToDelete | null) => void;
  workflowProps?: WorkflowComponentProps;
}

export const ADD_INCOME_SUCCESS_MESSAGE = 'Income added successfully.';
export const EDIT_INCOME_SUCCESS_MESSAGE = 'Income saved successfully.';

export const getIncomeOwnerModel = ({
  value,
  options,
}: {
  value: string;
  options: OwnerOptionsDTO;
}) => {
  const selectedOwnerOption = Object.values(options)
    .map(item => item)
    .flat()
    .find(owner => owner.Name === value);
  return [
    {
      ...selectedOwnerOption,
      Id: selectedOwnerOption.Id,
      Name: selectedOwnerOption.Name,
      OwnerType: selectedOwnerOption.OwnerType,
      Percentage: 1,
    },
  ];
};

const ADVANCED_FIELDS = {
  [IncomeType.Salary]: ['StartAge', 'EndAge', 'Inflation', 'IsTaxFree', 'SelfEmployed'],
  [IncomeType.Business]: ['IncomeGrowth', 'StartAge', 'EndAge', 'SelfEmployed'],
  [IncomeType.RealEstate]: ['IncomeGrowth', 'YearlyTaxableAmount'],
  [IncomeType.SocialSecurity]: [],
  [IncomeType.Other]: ['StartAge', 'EndAge', 'Inflation', 'IsTaxFree'],
};

export const getShowAdvanced = (
  income:
    | IncomeModel
    | {
        IncomeType: IncomeType | null;
        IsBasePlanIncome: boolean;
        Earner: string | null;
        Name: string | null;
      },
) => {
  if (!income) {
    return;
  }
  const advancedFields =
    income.IncomeType !== null && income.IncomeType !== undefined
      ? ADVANCED_FIELDS[income.IncomeType]
      : [];
  return advancedFields.some(field => !!income[field] || income[field] === 0);
};
